import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';
import i18next from 'i18next';
import { editEntityField } from '../../../actions';

class MenuTaxSetup extends Component {
    render() {
        const { entity } = this.props;

        if (!entity) return null;

        const { taxesSetup } = entity.options;

        const handleChange = (type, value) => {
            let calc = value && value >= 0 ? value / 100 : undefined;
            if (calc > 1) calc = undefined;
            this.props.editEntityField('options.taxesSetup', { ...taxesSetup, [type]: calc ? Number(calc.toFixed(5)) : undefined });
        };

        const calcValue = value => value != null ? Number((value * 100).toFixed(3)) : '';

        return (
            <Fragment>
                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('taxSetup')}
                        checked={!!taxesSetup}
                        onChange={(e, { checked }) => this.props.editEntityField('options.taxesSetup', checked ? {} : null)}
                    />
                </Form.Field>

                {taxesSetup &&
                    <Form.Group widths='equal'>
                        <Form.Field>
                            <Input
                                fluid
                                icon='food'
                                iconPosition='left'
                                max="100"
                                type="number"
                                step="any"
                                value={calcValue(taxesSetup.sitting)}
                                onChange={({ target }) => handleChange('sitting', target.value)}
                            />
                        </Form.Field>
                        <Form.Field style={{ paddingLeft: 0, paddingRight: 0, marginLeft: -5, marginRight: -5 }}>
                            <Input
                                fluid
                                icon='shopping bag'
                                iconPosition='left'
                                min="0" max="100"
                                type="number"
                                step="any"
                                value={calcValue(taxesSetup.takeaway)}
                                onChange={({ target }) => handleChange('takeaway', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Input
                                fluid
                                icon='motorcycle'
                                iconPosition='left'
                                min="0" max="100"
                                type="number"
                                step="any"
                                value={calcValue(taxesSetup.delivery)}
                                onChange={({ target }) => handleChange('delivery', target.value)}
                            />
                        </Form.Field>
                    </Form.Group>
                }
            </Fragment>
        );
    }
}

MenuTaxSetup.propTypes = {
    entity: PropTypes.object,
    editEntityField: PropTypes.func,

};

export default connect(null, { editEntityField })(MenuTaxSetup);
